function setLogin() {
    return dispatch => {
        dispatch({
            type: "setLogin"
        });
    };
}

function setLogout() {
    return dispatch => {
        dispatch({
            type: "setLogout"
        });
    };
}

export {
    setLogin,
    setLogout
};


// WEBPACK FOOTER //
// ./src/Actions/auth.js